/* eslint-disable */
// This file is auto gererated by build/build-entry.js
import '../plugins/iview'
import '../plugins/utils'
import '../plugins/table'
import '../plugins/codemirror'
import Api from './api'
import BaseCard from './base-card'
import Button from './button'
import Icon from './icon'
import Loading from './loading'
import Login from './login'
import TestPage from './test-page'
import TextCard from './text-card'
import TsCodeInput from './ts-code-input'
import TsDateInput from './ts-date-input'
import TsFormNavigator from './ts-form-navigator'
import TsFormula from './ts-formula'
import TsNumInput from './ts-num-input'
import TsPatternInput from './ts-pattern-input'
import TsPhoneInput from './ts-phone-input'
import TsPlottable from './ts-plottable'
import TsPlottableUi from './ts-plottable-ui'
import TsTable from './ts-table'
import TsTree from './ts-tree'
import TsTreeSelect from './ts-tree-select'
const version = '1.0.2'
const components = [
  Api,
  BaseCard,
  Button,
  Icon,
  Loading,
  Login,
  TestPage,
  TextCard,
  TsCodeInput,
  TsDateInput,
  TsFormNavigator,
  TsFormula,
  TsNumInput,
  TsPatternInput,
  TsPhoneInput,
  TsPlottable,
  TsPlottableUi,
  TsTable,
  TsTree,
  TsTreeSelect
]
const install = Vue => {
  components.forEach(Component => {
    Vue.use(Component)
  })
};
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  install,
  version,
  Api,
  BaseCard,
  Button,
  Icon,
  Loading,
  Login,
  TestPage,
  TextCard,
  TsCodeInput,
  TsDateInput,
  TsFormNavigator,
  TsFormula,
  TsNumInput,
  TsPatternInput,
  TsPhoneInput,
  TsPlottable,
  TsPlottableUi,
  TsTable,
  TsTree,
  TsTreeSelect
}
export default {
  install,
  version
}
